import type { TicketDetailMessage } from '@/types/api'

/** Нормализация ответа POST /messages/ или WS new_message в формат ленты карточки. */
export function ticketDetailMessageFromApi(raw: Record<string, unknown>): TicketDetailMessage | null {
  const id = raw.id != null ? String(raw.id) : ''
  if (!id) return null
  const attachments = Array.isArray(raw.attachments)
    ? raw.attachments.map((a) => {
        const att = a as Record<string, unknown>
        return {
          id: String(att.id ?? ''),
          filename: String(att.filename ?? ''),
          original_filename: String(att.original_filename ?? ''),
          file_path: String(att.file_path ?? ''),
          file_url: att.file_url != null ? String(att.file_url) : null,
          file_size: Number(att.file_size ?? 0),
          mime_type: String(att.mime_type ?? ''),
          file_type: String(att.file_type ?? 'other'),
          width: att.width != null ? Number(att.width) : null,
          height: att.height != null ? Number(att.height) : null,
          duration: att.duration != null ? Number(att.duration) : null,
          created_at: att.created_at != null ? String(att.created_at) : null,
        }
      })
    : undefined
  const quoted = raw.quoted_message as Record<string, unknown> | null | undefined
  return {
    id,
    ticket_id: String(raw.ticket_id ?? ''),
    user_id: raw.user_id != null ? String(raw.user_id) : null,
    message_type: String(raw.message_type ?? 'operator'),
    content: String(raw.content ?? ''),
    content_locale: raw.content_locale != null ? String(raw.content_locale) : null,
    content_translated: raw.content_translated != null ? String(raw.content_translated) : null,
    outbound_content: raw.outbound_content != null ? String(raw.outbound_content) : null,
    channel_delivery_status: raw.channel_delivery_status != null ? String(raw.channel_delivery_status) : null,
    delivery_error: raw.delivery_error != null ? String(raw.delivery_error) : null,
    sender_name: raw.sender_name != null ? String(raw.sender_name) : null,
    sender_email: raw.sender_email != null ? String(raw.sender_email) : null,
    is_internal: Boolean(raw.is_internal),
    is_bulk: Boolean(raw.is_bulk),
    created_at: raw.created_at != null ? String(raw.created_at) : null,
    customer_avatar: raw.customer_avatar != null ? String(raw.customer_avatar) : null,
    channel_name: raw.channel_name != null ? String(raw.channel_name) : null,
    channel_type: raw.channel_type != null ? String(raw.channel_type) : null,
    attachments,
    quote_message_id: raw.quote_message_id != null ? String(raw.quote_message_id) : null,
    quoted_message: quoted
      ? {
          id: String(quoted.id ?? ''),
          content: String(quoted.content ?? ''),
          content_locale: quoted.content_locale != null ? String(quoted.content_locale) : null,
          content_translated: quoted.content_translated != null ? String(quoted.content_translated) : null,
          outbound_content: quoted.outbound_content != null ? String(quoted.outbound_content) : null,
          sender_name: quoted.sender_name != null ? String(quoted.sender_name) : null,
          sender_email: quoted.sender_email != null ? String(quoted.sender_email) : null,
          message_type: String(quoted.message_type ?? ''),
          created_at: quoted.created_at != null ? String(quoted.created_at) : null,
          attachments: undefined,
        }
      : null,
  }
}

export function mergeTicketMessages(
  prev: TicketDetailMessage[],
  incoming: TicketDetailMessage,
): TicketDetailMessage[] {
  if (prev.some((m) => m.id === incoming.id)) return prev
  const next = [...prev, incoming]
  next.sort((a, b) => {
    const ta = a.created_at ? Date.parse(a.created_at) : 0
    const tb = b.created_at ? Date.parse(b.created_at) : 0
    if (ta !== tb) return ta - tb
    return a.id.localeCompare(b.id)
  })
  return next
}
